import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'outline' | 'accent';
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  className = ''
}: BadgeProps) {
  const variants = {
    default: 'bg-gray-800 text-gray-200 border border-gray-700',
    outline: 'bg-transparent text-gray-300 border border-gray-600',
    accent: 'bg-cyan-500/10 text-cyan-400 border border-cyan-500/20'
  };
  return <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${variants[variant]} ${className}`} data-id="element-249">
      {children}
    </span>;
}